import { Form } from 'antd';
import styles from './FormItem.module.scss';

const FormItem = ({
  children,
  message,
  name,
  label = '',
}: {
  children: JSX.Element;
  message?: string;
  name?: string;
  label?: string;
}) => {
  return (
    <div className={styles.formItem}>
      {!!message ? (
        <Form.Item
          style={{ width: '100%', marginBottom: 12 }}
          name={name}
          label={label}
          rules={[
            {
              required: true,
              message: message,
            },
          ]}
        >
          {children}
        </Form.Item>
      ) : (
        <Form.Item label={label} style={{ width: '100%', marginBottom: 12 }} name={name}>
          {children}
        </Form.Item>
      )}
    </div>
  );
};

export default FormItem;
